/** @jsxImportSource @emotion/react */

import React from 'react'
import { Collapse, List, Menu } from '@mui/material'
import { DrawerMainMenuItem } from '@components/systems/drawerMenu/DrawerMainMenuItem'

import { useAppSelector, MenuType } from '@redux/index'
import { useDrawerOpen } from '@components/systems/backoffice/BoShellContext'

interface PropsType {
	menu: MenuType
	anchorEl: any
	isOpenMainMenu: boolean
	onCloseSubmenu: () => void
}

/** 그룹의 자식 목록. 사이드바가 열려 있으면 안에서 펼치고, 접혀 있으면 옆에 메뉴로 띄운다 */
export const DrawerMainMenuList = (props: PropsType) => {
	// redux state
	const isOpenDrawer: boolean = useDrawerOpen()

	const onIsOpenSubmenu = React.useCallback(() => {
		props.onCloseSubmenu()
	}, [])

	return (
		<>
			{props.menu.children !== undefined ? (
				isOpenDrawer ? (
					<Collapse in={props.isOpenMainMenu} timeout={200} unmountOnExit>
						<List component="div" disablePadding>
							{props.menu.children.map((aMenu: MenuType) => (
								<DrawerMainMenuItem
									key={`${props.menu.id}-${aMenu.id}`}
									menu={aMenu}
									isFirstDepth={false}
								/>
							))}
						</List>
					</Collapse>
				) : (
					<Menu
						id={`group_${props.menu.id}_menu`}
						anchorEl={props.anchorEl}
						open={props.isOpenMainMenu}
						onClose={onIsOpenSubmenu}
						anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
						transformOrigin={{ vertical: 'top', horizontal: 'left' }}
						MenuListProps={{
							'aria-labelledby': `group_${props.menu.id}_button`,
						}}
						slotProps={{ paper: { sx: { minWidth: 200, ml: 1 } } }}
					>
						{props.menu.children.map((aMenu: MenuType) => (
							<DrawerMainMenuItem
								key={`${props.menu.id}-${aMenu.id}`}
								menu={aMenu}
								isFirstDepth={false}
							/>
						))}
					</Menu>
				)
			) : null}
		</>
	)
}
